export default __webpack_public_path__ + "static/media/kid_passport.2908b4e9.jpg";